import React from 'react'

import { Image, ResponsiveValue } from '@gousto-internal/citrus-react'

import newBadgeSticker from '../../assets/NewBadgeAssets/new-badge.svg'

export type CWCNewBadgeProps = {
  /**
   * Responsive width of the whole SVG canvas (which includes the drop-shadow
   * bleed). Defaults so the *visible* sticker matches the Figma "New" frame
   * (58px mobile, 96.69px from tablet up): the sticker occupies ~0.749 of the
   * canvas, so the canvas widths are 77px / 129px. Override when a reusing
   * section needs a different size.
   */
  width?: ResponsiveValue<string>
}

/**
 * Decorative "NEW" starburst sticker, shared across CWC homepage sections.
 *
 * It is purely decorative (a visual sticker, not information), so it renders with
 * an empty alt and `aria-hidden` and is excluded from the accessible tree. The
 * consuming section positions it via composition (e.g. wrapping it in a
 * positioned Box that overhangs a card).
 */
export const CWCNewBadge = ({ width = ['77px', null, '129px'] }: CWCNewBadgeProps) => (
  <Image data-testid="newBadge" src={newBadgeSticker} alt="" aria-hidden width={width} />
)
